import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";

export default function PdfView({ item }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
  }, [item?.url]);

  if (!item?.url) return null;

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            pointerEvents: "none",
          }}
        >
          <CircularProgress size={32} />
        </Box>
      )}
      <iframe
        src={`${item.url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
        title="PDF Viewer"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        onLoad={() => setLoading(false)}
      />
    </Box>
  );
}
